import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'normalize.css';
import '@fortawesome/fontawesome-free/css/all.css'; // Import Font Awesome CSS
import '@fortawesome/fontawesome-free/js/all.js'; // Import Font Awesome JS (optional)

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');

console.log('App mounted');